module.exports = __webpack_public_path__ + "img/wz-8-7-5.e75ff848.jpg";